export default function listenOnce(element, eventName, fn) {
    element.addEventListener(eventName, function listener(...args) {
        element.removeEventListener(eventName, listener);
        fn(...args);
    });
}
